import api from '../../../services/api';

const authService = {
  getMe: () => api.get('/auth/me'),
  // OTP login — restore when email verification is re-enabled
  // requestLoginOtp: (email, password, role, resend = false) =>
  //   api.post('/auth/request-otp', { email, password, role, resend }),
  //
  // verifyLoginOtp: (email, otp) =>
  //   api.post('/auth/verify-otp', { email, otp }),

  setPassword: (token, password) =>
    api.post('/auth/set-password', { token, password }),

  requestForgotPassword: (email) =>
    api.post('/auth/forgot-password', { email }),

  resetForgotPassword: (token, password) =>
    api.post('/auth/forgot-password/reset', { token, password }),
};

export default authService;
